// extracted by mini-css-extract-plugin
module.exports = {"m":"ua_m__tDgO9","bc":"ua_bc__BSGpR","bs":"ua_bs__2B_2J","btn":"ua_btn__eeutg","list-block":"ua_list-block__Gprvm","cs":"ua_cs__UKG0L"};